<template>
  <!-- 申请入会 -->
  <div id="Assocarticle">
    <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{ name: 'home' }">首页</router-link></span>
         <i class="iconfont icon-youjiantou"></i>
        <span ><router-link :to="{name:'aa'}">协会概况</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span
          ><router-link :to="{ name: 'Assocwindow' }"
            >申请入会</router-link
          ></span
        >
    </div>
    <p v-html="MemberList[0].Content"></p>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:'Assocarticle',
  data(){
    return{
      MemberList:[]
    }
  },
  components:{

  },
  methods:{
    getData(){
      axios.post('/SiteContentAPI/GetPageList',{
        ChannelID:2832,
        JournalID:202007100001,
        CurrentPage:1,
        PageSize:8
      }).then((res) => {
        this.MemberList = res.data._itemList
      })
    }
  },
  created(){
    this.getData();
  }
}
</script>

<style lang="less" scoped>
  #Assocarticle{
    width:100%;
    margin:0 auto;
          .crumbs {
    width: 1200px;
    height: 20px;
    position: relative;
    text-align: left;
    margin-top: 24px;
    margin-bottom: 20px;
    // margin-left: 2%;
    line-height: 20px;
    span:nth-child(2) a {
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
    i {
      color: #767c82;
      font-size: 18px;
      margin-left: 10px;
      font-weight: bold;
    }
    i:nth-child(1) {
      color: #000;
      margin-right: 5px;
    }
     span:nth-child(4) a {
      color: #000;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
    span:nth-child(6) a {
      color: #c01b22;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
  }
    p{
		  font-size:18px!important;
      color:#000!important;
      margin-top:26px;
      text-indent:2em;
      text-align:center;
      line-height:33px!important;
      text-align: justify;
      /deep/p{
        font-size:18px!important;
        color:#000!important;
        margin-top:18px!important;
        text-align:center!important;
        line-height:33px!important;
        text-align: justify!important;
      }
      /deep/span{
        font-size:18px!important;
        color:#000!important;
        margin-top:18px!important;
        text-align:center!important;
        line-height:33px!important;
        text-align: justify!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Assocwindow/Aplymember/index.vue